export const DelhiImages ={
    d1 : require('./port1.jpg').default,
    d2 : require('./port2.jpg').default,
    db1 : require('./arch1.jpg').default,
    db2 : require('./arch2.jpg').default,
    dc1 : require('./culture1.jpg').default,
    dc2 : require('./culture2.jpg').default,
    dh1 : require('./hotel1.jpg').default,
    dh2 : require('./hotel2.jpg').default,
    dp1 : require('./pack1.jpg').default,
    dp2 : require('./pack2.jpg').default,
    dp3 : require('./pack3.jpg').default,
    dp4 : require('./pack4.jpg').default,
    do1 : require('./only1.jpg').default,
    do2 : require('./only2.jpg').default,
}